import React, { Component } from 'react';
import ReduxStore from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import ModalBase from '../Base';
import strings from '../../../strings';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import JoyrideActions from '../../../actions/joyride';

class NewUserModal extends Component {
    static mapState = (state) =>
        mapSelectors(state, {
            visible: selectors.ui.getNewUserModalVisible,
        });

    static mapDispatch = (dispatch) => ({
        close: () => {
            dispatch(UiActions.closeModal('newUser'));
            dispatch(JoyrideActions.cancelJoyride());
        },
        startJoyride: () => {
            dispatch(UiActions.closeModal('newUser'));
            dispatch(JoyrideActions.startJoyride());
        },
    });

    _getContent() {
        // TODO if tour was started but no finished, return a diff msg
        return strings.startTheTour;
    }

    render() {
        return (
            <ModalBase
                modalClassName="new-user-modal"
                modalTitle={strings.welcome}
                visible={this.props.visible}
                closeModal={this.props.close}
            >
                <p>{this._getContent()}</p>
                <fieldset className="form-group text-right m-b-0">
                    <button
                        className="btn btn-info m-r-sm p-l-lg p-r-lg"
                        onClick={() => this.props.close()}
                    >
                        {strings.no}
                    </button>
                    <button
                        className="btn btn-success p-l-lg p-r-lg"
                        onClick={() => this.props.startJoyride()}
                    >
                        {strings.yes}
                    </button>
                </fieldset>
            </ModalBase>
        );
    }
}

export default ReduxStore.attach(NewUserModal);



// WEBPACK FOOTER //
// ./app/components/Modals/NewUserModal/index.jsx